import React from "react";
import "./Power_Progress.css";
import Common_Btn from "../../common/common-btn/Common_Btn";
import { useNavigate } from "react-router-dom";
import { PowerProgress } from "../../../utils/apis/homepage/index";
import { Power } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import { useLocation } from "react-router-dom";

const Power_Progress = () => {
  const navigate = useNavigate();

  // console.log(Power,"PowerPower")

  const { IMG_URL } = useContext(Context);
  const location = useLocation();

const [powerData, setPowerData] = useState([]);

 const getPower = async () => {
  try {
    const res = await Power();
    // console.log("Power API Response in component:", res?.data?.data);
    const actualData = res?.data?.data || [];
    setPowerData(actualData); 
  } catch (error) {
    console.error("Error fetching power data:", error);
  }
};

useEffect(() => {
  getPower();
}, []);


  console.log(powerData,"PowerPower");
  

  // const rowData = [
  //   {
  //     number: powerprogress?.happycustomers,
  //     text1: "Happy Customers",
  //     text2: "Trusted by homeowners, societies, and businesses.",
  //     img: "/assets/images/home/power_progress/rating.png"
  //   },
  //   {
  //     number: powerprogress?.qualitychecked,
  //     text1: "Quality Checked",
  //     text2: "Engineered for performance, safety, and long-term savings.",
  //     img: "/assets/images/home/power_progress/surface1.png"
  //   },
  //   {
  //     number: powerprogress?.energycostsavings,
  //     text1: "Energy Cost Savings",
  //     text2: "Smart solar solutions designed for maximum ROI.",
  //     img: "/assets/images/home/power_progress/profit.png"
  //   },
  //   {
  //     number: powerprogress?.supportmonitoring,
  //     text1: "Support & Monitoring",
  //     text2: "Ensuring uninterrupted solar performance year-round.",
  //     img: "/assets/images/home/power_progress/support.png"
  //   },
  // ];

  // console.log(process.env.REACT_APP_BASE_URL,"link")

  return (
    <section className="Power_Progress">
      <div className="container">
        <div className="power_banner_div">
          <div className="power_banner_content_holder">
            <div className="power_banner_header">
              <h5 className="banner_header">Powering Progress Across India</h5>
              <p className="banner_subtitle">
                Real achievements that showcase our growing solar footprint and
                proven expertise.
              </p>
            </div>

            <div className="container">
              <div className="banner_row_holder">
                <div className="row justify-content-center">

                  {powerData?.map((item, index) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 mb-5"
                      key={index}
                    >
                      <div className="banner_col_holder">

                        <div className="col_img_holder">
                          
                          <img
                            src={IDS?.IMG_URL + item?.logo}
                            style={{ height: "100%", width: "100%",objectFit:"" }}
                            alt={item.text1}
                            className="col_img"
                          />
                        </div>

                        <div className="col_content_holder">
                          <h5 className="col_number">{item?.value}</h5>
                          <p className="col_text1">{item?.title}</p>
                          <p className="col_text2"> {item?.description?.replace(/<[^>]+>/g, "")}</p>
                        </div>

                      </div>
                    </div>
                  ))}
                  
                </div>
              </div>
            </div>

            <div
              className="know_more_btn"
              onClick={() => navigate("/about-us")}
            >
              {/* <div className="btn_wrapper">
                   <Common_Btn text={"Know More about us"} />

              </div>
            */}
            {location.pathname !== "/about-us" && (
  <div className="btn_wrapper">
    <Common_Btn text={"Know More about us"} />
  </div>
)}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Power_Progress;